import React, { Component } from 'react';
import golbeldata from '../data.json';
import { Link, Route, Switch } from 'react-router-dom';

class Appnav extends Component {

  componentDidMount() {

  }
  render() {
    return (<div class="navbar yamm navbar-default" id="sticky">
      <div class="container">
        <div class="navbar-header">
          <button type="button" data-toggle="collapse" data-target="#navbar-collapse-grid" class="navbar-toggle"> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>
          <Link to="/" className="navbar-brand">
            <div id="logo"> {this.props.data.HotelName}  </div>
          </Link>
        </div>
        <div id="navbar-collapse-grid" class="navbar-collapse collapse">
          <ul class="nav navbar-nav">
            <li class="dropdown active"> <Link to="/">Home</Link>
            </li>
            <li class="dropdown"> <Link to="/rooms">Rooms</Link>
            </li>
            <li class="dropdown"> <Link to="/explore">Explore</Link>
            </li>
            <li class="dropdown"> <Link to="/gallery">Gallery</Link>
            </li>
            <li class="dropdown"> <Link to="/reservation">Reservation</Link>
            </li>
            <li class="dropdown"> <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>)
  }
}
export default Appnav;



// WEBPACK FOOTER //
// ./src/components/Appnav.js